// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinkStyles } from "@keller/Overrides/Widgets/Common/CartLink";
import { styledScrollbar } from "@keller/XDL/Utilities/scroll";
import { css } from "styled-components";

cartLinkStyles.floatingTooltip = {
    tooltipContent: {
        css: css`
            width: 100%;
            max-width: 467px;
            max-height: calc(100vh - ${({ headerHeight }: any) => headerHeight ?? 152}px);
        `,
    },
    tooltipInnerContent: {
        css: css`
            scrollbar-gutter: stable;
            max-height: inherit;
            ${styledScrollbar(2)}
        `,
    },
};
